const formatter = new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
  timeZone: 'UTC',
});

/** Format a date as "YYYY-MM-DD HH:mm" in UTC (24-hour format) */
export const formatYYYYMMDDHHmmUtc = (date: Date | string): string => {
  const parts = formatter.formatToParts(new Date(date));
  const getPart = (type: Intl.DateTimeFormatPart['type']) =>
    parts.find((part) => part.type === type)?.value ?? '';

  return `${getPart('year')}-${getPart('month')}-${getPart('day')} ${getPart('hour')}:${getPart('minute')}`;
};

const REGEX_ISO_DATE_TIME = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/;

/** Format an ISO date string as "YYYY.MM.DD (HH:mm)" preserving the original timezone offset from the input */
export const formatYYYYMMDDHHmmParseZone = (value?: string): string => {
  if (!value) {
    return '';
  }

  const match = value.match(REGEX_ISO_DATE_TIME);

  if (!match) {
    return '';
  }

  const [, year, month, day, hour, minute] = match;

  return `${year}.${month}.${day} (${hour}:${minute})`;
};
